export default __webpack_public_path__ + "static/Fig 1 - Site Location Map-9f4213d6bfc69a66f2ba000d4cf2c7b1.pdf";